import { DatePipe, DecimalPipe, NgClass, NgTemplateOutlet, TitleCasePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { GoalModel } from '@bp-core/src/lib/proto/common-message.pb';
import { TransactionRequestType } from '@bp-core/src/lib/proto/goal-transaction-enums.pb';
import { GoalTransactionPaymentMethod } from '@bp-core/src/lib/proto/goal-transaction-payment-enum.pb';
import { GoalTransactionType } from '@bp-core/src/lib/proto/goal-transaction-type-enums.pb';
import { GoalTransactionFundingModel } from '@bp-core/src/lib/proto/portal-goal.pb';
import { GetMeActivitiesResponse, GetMeActivity } from '@bp-core/src/lib/proto/portal-user.pb';
import { UserService } from '@bp-core/src/lib/services/portal/user.service';
import { fuseAnimations } from '@fuse/animations';
import { GoalActivityDetail } from 'bp/modules/goal/models/goal-activity-detail.model';
import { GoalDrawerContentService } from 'bp/modules/goal/services/goal-drawer-content.service';
import { getGreenColor } from 'bp/shared/chart/betterplan-theme-amchart';
import { BpConfirmationService } from 'bp/shared/services/bp-confirmation.service';
import { BpCoreModule } from '../../../../../../bp-core/src/lib/bp-core.module';

@Component({
  selector: 'goal-activity',
  templateUrl: './goal-activity.component.html',
  styleUrls: ['./goal-activity.component.scss'],
  animations: fuseAnimations,
  standalone: true,
  imports: [
    BpCoreModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    NgTemplateOutlet,
    NgClass,
    MatPaginatorModule,
    MatDividerModule,
    DecimalPipe,
    TitleCasePipe,
    DatePipe,
    MatSidenavModule,
    MatRippleModule,
    MatTooltipModule,
  ],
})
export class GoalActivityComponent implements OnInit, OnChanges, AfterViewInit {
  activities: GetMeActivity[] | undefined = undefined;
  activitiesDataSource: MatTableDataSource<GetMeActivity> = new MatTableDataSource();
  activitiesTableColumns: string[] = ['Fecha', 'meta', 'Operación', 'Descripción', 'Monto'];
  columnsToDisplayWithExpand = ['Operación', 'Monto', 'expand'];
  greenColor = getGreenColor(0);
  activity: GetMeActivity;
  goalTransactionType = GoalTransactionType;
  expandedElement: GetMeActivity | null;
  paymentMethod = GoalTransactionPaymentMethod;
  activityFromRoute: GetMeActivity | undefined;
  // showDrawer = signal(false);
  // drawerMode: WritableSignal<'side' | 'push' | 'over'> = signal('over');
  @Input() goalActivitiesResponse: GetMeActivitiesResponse;
  @Input() currentGoal: GoalModel;
  @Input() showExportToExcel: boolean = false;
  @Input() hasFilters: boolean = false;
  @Input() activityIdFromRoute: number;

  @Output() toggleFilter = new EventEmitter<void>();

  @Output() onPageChanged = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('detail') detail: ElementRef;

  constructor(
    private userService: UserService,
    private bpConfirmationService: BpConfirmationService,
    private router: Router,
    private goalDrawerContentService: GoalDrawerContentService<GoalActivityDetail>,
  ) {}

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 50, 100];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentGoal?.currentValue) {
      this.activitiesTableColumns = ['Fecha', 'Operación', 'Descripción', 'Monto'];
    }
    if (changes.goalActivitiesResponse?.currentValue) {
      this.activitiesDataSource.data = this.goalActivitiesResponse?.values || [];
      this.activities = this.goalActivitiesResponse?.values || [];
      this.totalRows = this.goalActivitiesResponse?.rowCount ?? 0;
      this.activityFromRoute = this.activities?.find(
        a => a.requestId?.value === this.activityIdFromRoute,
      );
      setTimeout(() => {
        if (this.activityFromRoute && this.detail) {
          this.showDetail(this.activityFromRoute, this.detail);
        }
      }, 100);
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    //    this.activitiesDataSource.paginator = this.paginator;

    if (this.activityFromRoute && this.detail) {
      this.showDetail(this.activityFromRoute, this.detail);
    }
  }

  pageChanged(event) {
    this.activities = undefined;
    this.onPageChanged.emit(event);
  }

  trackByFn(index: number, item: GetMeActivity): any {
    return item.requestId || index;
  }

  getAmountClass(activity: GetMeActivity) {
    const greenClass = 'text-charts-green-700';
    const redClass = 'text-brand-red';
    const blackClass = 'text-black';
    if (
      activity.type ===
        (TransactionRequestType.TransferGoal ||
          activity.type === TransactionRequestType.ChangePortfolio) &&
      !this.currentGoal
    ) {
      return {
        [blackClass]: true,
      };
    }

    return {
      [greenClass]: activity.isPositive,
      [redClass]: !activity.isPositive,
    };
  }

  onExportToExcel() {
    // if (this.goalActivitiesResponse?.values?.length! > 0) {
    //   this.userService.exportActivitiesToXlxs(this.goalActivitiesResponse?.values!);
    // }
  }

  showDetail(row: GetMeActivity, template: any) {
    setTimeout(() => {
      this.activity = row;
      this.goalDrawerContentService.openDrawer({
        content: {
          goalActivity: row,
        },
        type: 'goal-activity',
      });
    }, 200);
  }
  goToGoalFrom(goal: GetMeActivity.Goal) {
    this.router.navigate(['/goals', goal.id], {
      fragment: 'summary',
    });
  }
  getAbsoluteValue(number: number): number {
    return Math.abs(number);
  }

  getGoalTitle(row: GetMeActivity): string {
    // Si es una transferencia entre meta de tipo buy, la meta a mostrar es la de destino
    // if (row.type === this.goalTransactionType.TRANSFER_GOAL_BUY) return row.goalTo?.title!;
    // return row.goalFrom?.title!;
    return '';
  }

  getGoalTransactionDeposit(activity: GetMeActivity) {
    //obtener aporte de la transaccion
    // return activity.goalTransactionFundings?.filter(
    //   f => this.activity.id?.value != f.transactionId && f.type == this.goalTransactionType.DEPOSIT,
    // );
  }

  getGoalTransactionFundings(activity?: GetMeActivity) {
    // const transactionBox = activity?.goalTransactionFundings?.find(
    //   f => f.isBox && this.activity.id?.value == f.transactionId,
    // );
    // if (
    //   (this.currentGoal?.goalCategory?.code == 'caja-moneda' ||
    //     activity?.goalFrom?.goalCategory?.code == 'caja-moneda') &&
    //   activity?.type == GoalTransactionType.BUY
    // ) {
    //   return activity.goalTransactionFundings?.filter(
    //     f => f.id != transactionBox?.id && f.currency?.id != activity.currencyId,
    //   );
    // } else {
    //   return activity?.goalTransactionFundings?.filter(
    //     f => f.id != transactionBox?.id && this.activity.id?.value == f.transactionId,
    //   );
    // }
  }

  getBoxReInvest(activity?: GetMeActivity) {
    // if (activity?.type == this.goalTransactionType.DEPOSIT) {
    //   return null;
    // }
    // return activity?.goalTransactionFundings?.find(
    //   f =>
    //     f.isBox &&
    //     activity.id?.value != f.transactionId &&
    //     f.transactionPaymentMethod == GoalTransactionPaymentMethod.REINVEST,
    // );
  }

  getBox(activity?: GetMeActivity) {
    // //TODO: considerar que sea la caja de la moneda de la transaccion
    // return activity?.goalTransactionFundings?.find(
    //   f => f.isBox && this.activity.id?.value == f.transactionId,
    // );
  }
  getMnemonic(activity: GetMeActivity, goalTransactionFunding: GoalTransactionFundingModel) {
    // if (activity.id?.value == goalTransactionFunding.transactionId) {
    //   if (activity.type === this.goalTransactionType.DIVIDEND) {
    //     return goalTransactionFunding.originMnemonic;
    //   }
    //   return goalTransactionFunding.mnemonic;
    // } else {
    //   if (activity.type === this.goalTransactionType.DIVIDEND) {
    //     return goalTransactionFunding.originMnemonic;
    //   }
    //   if (goalTransactionFunding.type === this.goalTransactionType.DEPOSIT) {
    //     return 'Aporte';
    //   }
    //   return goalTransactionFunding.mnemonic;
    // }
  }
}
